import type { FC } from 'react';

import Banner from '@/components/UI/Banner';
import type { Approval } from '@/model/Approval.model';
import type { Study } from '@/model/Study.model';
import { Status } from '@/referenceData/study/status';

interface OutstandingReviewsBannerProps {
  study: Study;
  approvals?: Array<Approval>;
}

const OutstandingReviewsBanner: FC<OutstandingReviewsBannerProps> = ({ study, approvals }) => {
  const hasApprovals = (approvals?.length ?? 0) > 0;
  const isAwaitingApproval = study.status === Status.awaiting_approval;

  if (!hasApprovals || !isAwaitingApproval) {
    return null;
  }

  return (
    <Banner warning className="mw6 mb4" dismiss={false} center>
      <h3 className="lh-title f4 mb2">Action required</h3>
      <h3 className="f6 normal lh-copy">
        This study has outstanding reviews that need to be completed before it can begin.
      </h3>
    </Banner>
  );
};

export default OutstandingReviewsBanner;
